import type { ReactNode } from 'react';
import { Loader } from '@/shared/components';
import ExchangeQuickSelectButton from './ExchangeQuickSelectButton';
import {
  type ExchangeAsset as ExchangeAssetType,
  type ExchangeInputSectionType,
  useExchangeQuickSelect,
} from '../model';

type Props = {
  onSelect: (asset: string) => void;
  type: ExchangeInputSectionType;
  assetsOptions: Array<ExchangeAssetType>;
  loadingFallback?: ReactNode;
};

const ExchangeQuickSelectSection = ({
  onSelect,
  type,
  assetsOptions,
  loadingFallback = <Loader />,
}: Props) => {
  const { exchangeQuickSelectData, isExchangeQuickSelectLoading } =
    useExchangeQuickSelect(type, assetsOptions);

  return isExchangeQuickSelectLoading ? (
    loadingFallback
  ) : (
    <div className="flex flex-wrap items-center justify-end gap-[0.8rem]">
      {exchangeQuickSelectData.map(({ asset }, index) => (
        <ExchangeQuickSelectButton
          key={`${asset.code}-${index}`}
          asset={asset}
          onClick={() => onSelect(asset.code)}
        />
      ))}
    </div>
  );
};

export { ExchangeQuickSelectSection };
